export class ClosurePeriodSettingPutRequest {
  closurePeriodSettingId: string
  ownerNotificationId: string
  closureStartDate: string
  closureEndDate: string
  memo?: string

  constructor(closurePeriodSettingId: string, ownerNotificationId: string, closureStartDate: string, closureEndDate: string, memo?: string) {
    this.closurePeriodSettingId = closurePeriodSettingId
    this.ownerNotificationId = ownerNotificationId
    this.closureStartDate = closureStartDate
    this.closureEndDate = closureEndDate
    this.memo = memo
  }
}
